import NewDetails from '~components/new-chat/details'

export default NewDetails
